import apiClient from '../../shared/services/apiClient';

/** 资源转移（用户端 /api/user/transfers*）。错误统一抛出 {error} 体。 */
const call = async (p) => {
    try {
        const res = await p;
        return res.data?.data;
    } catch (e) {
        throw e.response?.data || e;
    }
};

const transferService = {
    list: (dir) => call(apiClient.get('/api/user/transfers', { params: dir ? { dir } : {} })),
    pendingCount: () => call(apiClient.get('/api/user/transfers/pending-count')),
    verifyMethod: () => call(apiClient.get('/api/user/transfers/verify-method')),
    preview: (type, id, recipient) => call(apiClient.post('/api/user/transfers/preview', { type, id, recipient })),
    create: (payload) => call(apiClient.post('/api/user/transfers', payload)),
    accept: (id) => call(apiClient.post(`/api/user/transfers/${id}/accept`)),
    decline: (id) => call(apiClient.post(`/api/user/transfers/${id}/decline`)),
    cancel: (id) => call(apiClient.post(`/api/user/transfers/${id}/cancel`)),
};

export const TRANSFER_TYPE_LABELS = {
    evm: 'Cloud server', domain: 'Domain', cdn: 'CDN domain', dns: 'DNS zone', host_shared: 'Shared hosting', host: 'Dedicated Container (legacy)', container: 'Dedicated container',
};

export default transferService;
